import template from './rw-icon.html';

class RwIconController {
  $onInit(){
    this.iconSize = this.size ? `fa-${this.size}` : '';
    this.iconEffect = this.effect ? `fa-${this.effect}` : '';
    this.iconType = this.type ? `fa fa-${this.type}` : 'fa fa-pencil';
  } 
}

export default class RwIconComponent {
  constructor() {
    this.controller = RwIconController;
    this.template = template;
    this.bindings = {
      type: '@?',
      size: '@?',
      effect: '@?',
      iconStart: '<?',
      iconEnd: '<?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-icon/rw-icon-component.js